import { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import axiosInstance from "./axiosInstance.js";
import { baseUrl } from "./endpoints.js";
import { configReq } from "../lib/functions.js";

/** Legacy inline-edit transport shared by tables; preserves payload and update semantics. */
export function useTableRowActions({ row, rows, setAllRows, editApi, editInputApi }) {
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.user);
  const handleActive = () => {
    if (editApi) {
      const formData = new  FormData()
      formData.append("id" , row?.id)
      setLoading(true);
      var temp = [...rows];
      axiosInstance
        .put(`${baseUrl}/${editApi}`, formData, configReq(token))
        .then((res) => {
          setLoading(false);
          toast.success("با موفقیت ویرایش شد");
          var index = temp.findIndex((item) => item.id === row.id);
          temp[index] = res.data.data;
          setAllRows(temp);
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);
        });
    }
  };
  const handleInput = (value, name) => {
    if (editInputApi) {
      axiosInstance
        .put(
          `${baseUrl}/${editInputApi}`,
          { ...row, [name]: value },
          configReq(token)
        )
        .then((res) => {  toast.success("با موفقیت ویرایش شد");})
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);
        });
    }
  };
  return { loading, handleActive, handleInput };
}
